<template>
	<div class="benefits">
		<h2 class="title">What we do</h2>
		<div class="top-text">
			<span>Duckist.com</span> is helps you share secrets such as passwords, messages elegantly and easily.
		</div>
		<ul class="list">
			<li class="item">
				<p>
					Start chat rooms available only to those who have the chat room link
				</p>
			</li>
			<li class="item">
				<p>
					Messages are encrypted in your browser to ensure they are not even accessible to Duckist.com
				</p>
			</li>
			<li class="item" v-if="message_expire == 10">
				<p class="mb-0">Messages self-destruct after only 10 minutes</p>
			</li>
			<li class="item" v-else-if="message_expire == 1440">
				<p class="mb-0">Messages self-destruct after only 1 day</p>
			</li>
			<li class="item" v-else-if="message_expire == 43200">
				<p class="mb-0">Messages self destruct after only 1 month</p>
			</li>
		</ul>
		<Flash ref="show"/>
	</div>
</template>

<script>
	import Flash from "../components/Flash";

	export default {
		name: 'ChatBenefits',
		components: {
			Flash
		},
		props: {
			message_expire: ""
		},
		data() {
			return {
			}
		},
		methods: {

		},
		mounted() {
		}
	}
</script>

<style scoped lang="scss">
	@import "../assets/scss/benefits.scss";

	.link {
		color: #fff;
		text-decoration: none;
		font-weight: 600;
		word-break: break-all;
	}


</style>
